import { Order } from './order.interface';

export interface AveryMaterial {
  materialId: string;
  name: string;
  displayName: string;
  magentoLabel: string;
  outOfStock: boolean;
  format: 'roll' | 'sheet' | 'sticker';
}
export interface OrderState {
  orderPeriods: OrderPeriods;
  sortType: string;
  prepProofList: Array<Order>;
  approvalList: Array<Order>;
  inProductionList: Array<Order>;
  prepShippingList: Array<Order>;
  shippedList: Array<Order>;
  cancelledList: Array<Order>;
  orderStatus: string;
  total: number;
  displayAmt: number;
  refreshList: string;
  averyMaterials: Array<AveryMaterial>; // Replace 'any' with the appropriate type if available
}

export interface OrderPeriods {
  orderTime: string;
  aryProcess30Days: Array<Order>;
  aryProcess6Months: Array<Order>;
  aryProcess12Months: Array<Order>;
  aryComplete30Days: Array<Order>;
  aryComplete6Months: Array<Order>;
  aryComplete12Months: Array<Order>;
}
